import 'jquery.easing'
import './plugins/togglemenu'
import HOME from './page/home'

const [w,d,l] = [window,document,window.location];

switch(l.pathname){
  case '/': HOME(); break
}

const init = () => {}

d.addEventListener('DOMContentLoaded',init)
